module.exports = __webpack_public_path__ + "img/ai-logo.5ac07671.svg";